var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { colors as tooltipColors } from './tooltip';
var primary = ['#0089ff', '#00294d'];
var secondary = ['#fc6e51', '#fec333', '#906ed3', '#00c8d7', '#2ecc71'];
var neutral = ['#335471', '#5c768d', '#7e94a7', '#d0d8de', '#e1e0e6', '#f7f9fb'];
var redColor = ['#bb3420', '#e3472d', '#fc6e51', '#fdcbc0', '#f9e9e8'];
var orangeColor = ['#fa6918', '#fc991b', '#fec333', '#ffe9b4', '#fff7e1'];
var purpleColor = ['#361da7', '#5d30bd', '#906ed3', '#cfc1eb', '#ede7f6'];
var cyanColor = ['#00858d', '#00aebf', '#00c8d7', '#aaecef', '#ddf8f9'];
var greenColor = ['#006e1e', '#009f3e', '#2ecc71', '#c0edcd', '#e5f8eb'];
var blueColor = ['#002fa1', '#1463d8', '#0089ff', '#badfff', '#e3f2ff'];
var $white = '#fff';
// if bg color is one of primary[0], neutral[0,1,2], redColor[0,1], orangeColor[0,1], purpleColor[0,1], cyanColor[0,1], greenColor[0,1], blueColor[0,1 then textColor will be #fff else #00294d 
var bgColorByTextColor = (_a = {
        '#fff': [
            primary[0], primary[1], neutral[0], neutral[1], neutral[2], redColor[0], redColor[1], orangeColor[0], orangeColor[1],
            purpleColor[0], purpleColor[1], cyanColor[0], cyanColor[1], greenColor[0], greenColor[1], blueColor[0], blueColor[1]
        ]
    },
    _a[primary[1]] = [
        secondary[1], secondary[3], secondary[4], neutral[2], neutral[3], neutral[4], neutral[5],
        redColor[3], redColor[4], orangeColor[2], orangeColor[3], orangeColor[4], purpleColor[3], purpleColor[4],
        cyanColor[2], cyanColor[3], cyanColor[4], greenColor[2], greenColor[3], greenColor[4], blueColor[3], blueColor[4],
    ],
    _a);
var bgColor = {
    base: neutral[5],
    dark: '#253858',
    grey: neutral[2],
    error: secondary[0],
    warning: secondary[1],
    info: secondary[3],
    success: secondary[4],
    disabled: neutral[4],
};
var colorMap = {
    primaryColor: primary[1],
    secondaryColor: neutral[0],
    tertiaryColor: neutral[1],
    heading: primary[1],
    subHeading: neutral[2],
    label: neutral[2],
    disabled: neutral[4],
    error: secondary[0],
    warning: secondary[1],
    info: secondary[3],
    success: secondary[4],
    primaryBlue: primary[0],
};
var height = {
    small: '34px',
    large: '40px',
    auto: 'auto',
    default: '40px',
};
var doconTheme = {
    borderRadius: '4px',
    borderColor: neutral[4],
    height: height,
    colors: {
        primary: primary,
        secondary: secondary,
        blueColor: blueColor,
        link: primary[1],
        heading: primary[1],
        body: neutral[2],
        label: neutral[2],
        error: '#bf2600',
        white: $white,
        button: {
            primary: {
                color: $white,
                bgColor: primary[0],
                borderColor: primary[0],
                hoverBgColor: blueColor[1],
                hoverBorderColor: blueColor[1],
            },
            secondary: {
                color: primary[0],
                bgColor: $white,
                borderColor: neutral[4],
                hoverBorderColor: primary[0],
            },
            tertiary: {
                color: primary[0],
                borderColor: 'transparent',
            },
            // link: {
            //   color: primary[0],
            //   bgColor: 'transparent',
            //   borderColor: 'transparent',
            //   hoverColor: blueColor[1],
            //   hoverBgColor: $white,
            // },
            disabled: {
                color: neutral[2],
                bgColor: neutral[4],
                borderColor: neutral[4],
            },
            icon: {
                color: primary[1],
            }
        },
        input: {
            color: primary[1],
            borderColor: neutral[4],
            bgColor: $white,
            placeholderColor: neutral[3],
            hoverBgColor: 'rgba(0, 137, 255, 0.08)',
            focusBorderColor: primary[0],
            focusOptionBgColor: blueColor[4],
        },
        disabled: {
            color: neutral[2],
            bgColor: neutral[4],
            borderColor: neutral[4],
        },
        tooltip: tooltipColors,
        borderColor: neutral[4],
        table: {
            evenRowBg: 'rgba(0, 137, 255, 0.08)',
            header: colorMap.primaryColor,
            headerBg: bgColor.base,
            body: colorMap.secondaryColor,
        },
        text: {
            primaryColor: colorMap.primaryColor,
            secondaryColor: colorMap.secondaryColor,
            tertiaryColor: colorMap.tertiaryColor,
            heading: colorMap.heading,
            subHeading: colorMap.subHeading,
            primaryBlue: primary[0],
        },
        solidTab: {
            color: colorMap.secondaryColor,
            bgColor: $white,
            hoverColor: colorMap.primaryBlue,
            selectedColor: $white,
            selectedBgColor: colorMap.primaryBlue,
            selectedBgHoverColor: '#017FEC',
        },
    },
    backgroundColour: __assign({ text: ["#F6F7F8"], hover: ["#017FEC", "#EAEAEA", "#F0334B"] }, bgColor),
    typography: {
        heading: {
            'h1': {
                size: '25px',
                lineHeight: '36px',
            },
            'h2': {
                size: '21px',
                lineHeight: '30px',
            },
            'h3': {
                size: '18px',
                lineHeight: '26px',
            },
            'h4': {
                size: '16px',
                lineHeight: '24px',
            },
        },
        body: {
            'body1': {
                size: '14px',
                lineHeight: '20px',
            },
            'body2': {
                size: '12px',
                lineHeight: '16px',
            }
        }
    },
    sideNav: {
        color: primary[1],
        iconColor: neutral[2],
        bgColor: neutral[5],
        hoverBgColor: '#eef0f2',
        selectedColor: primary[0],
        selectedBgColor: 'rgba(0, 137, 255, 0.08)', //`rgba(${primary[0]}, 0.08)`,
    },
    chip: {
        color: primary[1],
        bgColor: $white,
        borderColor: neutral[4],
        hoverColor: primary[1],
        hoverBgColor: 'rgba(0, 137, 255, 0.08)',
        hoverBorderColor: neutral[4],
        selectedColor: primary[0],
        selectedBgColor: 'rgba(0, 137, 255, 0.08)',
        selectedBorderColor: primary[0],
    },
    modal: {
        bgColor: $white,
        overlayColor: 'rgba(0,0,0,.45)',
        borderColor: neutral[4],
        closeIconColor: neutral[1],
        closeIconHoverColor: primary[1],
    },
    step: {
        borderColor: neutral[4],
        activeBorderColor: colorMap.primaryBlue,
        iconColor: colorMap.subHeading,
        activeIconColor: colorMap.primaryBlue,
    },
    menuList: {
        color: primary[1],
        bgColor: $white,
        borderColor: neutral[4],
        hoverColor: blueColor[2],
        hoverBorderColor: blueColor[1],
        selectedColor: $white,
        selectedBgColor: blueColor[2],
        selectedBorderColor: blueColor[1],
    },
    toast: {
        light: {
            textColor: colorMap.primaryColor,
            color: $white,
            colorInfo: colorMap.info,
            colorSuccess: colorMap.success,
            colorWarning: colorMap.warning,
            colorError: colorMap.error,
        },
        dark: {
            textColor: $white,
            color: bgColor.dark,
        },
        colored: {
            textColorInfo: cyanColor[1],
            textColorSuccess: greenColor[1],
            textColorWarning: orangeColor[1],
            textColorError: redColor[1],
            colorInfo: cyanColor[4],
            colorSuccess: greenColor[4],
            colorWarning: orangeColor[4],
            colorError: redColor[4],
        },
    }
};
var colors = {
    primary: primary,
    secondary: secondary,
    neutral: neutral,
    redColor: redColor,
    orangeColor: orangeColor,
    purpleColor: purpleColor,
    cyanColor: cyanColor,
    greenColor: greenColor,
    blueColor: blueColor
};
export { doconTheme, colors, bgColorByTextColor };
